<template>
  <div class="textit_background_home has-text-centered">
    <div class="form_login">
      <img
        src="~@/assets/public_logo.png"
        class="public_home_logo"
      >
      <div class="field">
        <div class="control has-text-centered">
          <input
            name="URLPARTICIPANT"
            class="input is-large"
            type="text"
            :placeholder="$t('placeholder.participer')"
            v-model="url_participant"
          ><br><br>
          <button
            class="button"
            v-bind="{'disabled':!this.url_participant}"
            @click="RejoindreMeeting"
          >{{ $t("button.connecter") }}</button>
        </div>
      </div>
    </div>
    <footer>
      {{ $t("footer.credit") }}
      <b-field class="locale-changer">
        <b-select
          v-model="$i18n.locale"
          placeholder="Langue"
          icon="globe"
          icon-pack="fas"
          :input="onChange()"
          id="selectlangue"
        >
          <option
            v-for="(lang, i) in langs"
            :key="`Lang${i}`"
            :value="lang"
          >{{ lang }}</option>
        </b-select>
      </b-field>
    </footer>
  </div>
</template>

<script>
// import axios from 'axios'

export default {
  data () {
    return {
      url_participant: '',
      langs: ['fr', 'en']
    }
  },
  components: {

  },
  methods: {
    RejoindreMeeting (evt) {
      this.$router.push({ name: 'board', params: { url_participant: this.url_participant } })
    },
    onChange (event) {
      if (document.getElementById('selectlangue')) {
        var selectlangue = document.getElementById('selectlangue').value
        this.$store.dispatch('changeLangue', selectlangue)
      }
    }
  }
}
</script>

<style scoped>
.textit_background_home {
  height: 100%;
  background: #e6ecf0;
  background-repeat: no-repeat;
  background-position: top center;
}

.input {
  width: 100%;
  border-radius: 5px;
  color: #707070;
  -moz-box-shadow: 0px 5px 20px 0px #656565;
  -webkit-box-shadow: 0px 5px 20px 0px #656565;
  -o-box-shadow: 0px 5px 20px 0px #656565;
  box-shadow: 0px 5px 20px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=20);
}

.public_home_logo {
  border-radius: 13px;
  margin: 60px 0;
  width: 150px;
}

.button {
  padding: 25px 30px;
  line-height: 5px;
  color: #707070;
  border-radius: 5px;
  text-transform: uppercase;
}

.form_login {
  width: 300px;
  margin: 0px auto;
}

footer {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
  padding: 15px;
}
.locale-changer {
  position: absolute;
  right: 5px;
  top: 1px;
}
.control {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue